import { render } from "./UserArea.vue?vue&type=template&id=d28991b0"
import script from "./UserArea.vue?vue&type=script&lang=js"
export * from "./UserArea.vue?vue&type=script&lang=js"

import "./UserArea.vue?vue&type=style&index=0&id=d28991b0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UserArea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d28991b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d28991b0', __exports__)) {
    api.reload('d28991b0', __exports__)
  }
  
  module.hot.accept("./UserArea.vue?vue&type=template&id=d28991b0", () => {
    api.rerender('d28991b0', render)
  })

}


export default __exports__